import fetch from 'isomorphic-fetch';
import environment from '../../environment';

const { caUrl, caAuthorization } = environment;
const headers = {
  'Content-Type': 'application/json',
  Authorization: caAuthorization,
};

// Handle HTTP errors because fetch won't
const handleAPIError = error => {
  const message = error.statusText || 'Unknown error';
  throw Error({ error, message });
};

const handleAPIResponse = response => {
  // write all Error handling , logging code here
  if (!response.ok) {
    handleAPIError(response);
  }
  return response.json();
};

// Fetch/GET data from API
export const getAPI = url =>
  fetch(`${caUrl}${url}`, {
    method: 'GET',
    headers,
  })
    .then(handleAPIResponse)
    .catch(handleAPIError);

// Send data
export const postAPI = (url, requestPayload) =>
  fetch(`${caUrl}${url}`, {
    method: 'POST',
    body: JSON.stringify(requestPayload),
    headers,
  }).then(handleAPIResponse);

// Update data
export const putAPI = (url, requestPayload) =>
  fetch(`${caUrl}${url}`, {
    method: 'PUT',
    body: JSON.stringify(requestPayload),
    headers,
  }).then(handleAPIResponse);

// Delete data
export const deleteAPI = (url, requestPayload) =>
  fetch(`${caUrl}${url}`, {
    method: 'DELETE',
    body: JSON.stringify(requestPayload),
    headers,
  }).then(handleAPIResponse);
